/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Settings_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Style guide settings" |
*
* @param {Style_Guide_Manager_Settings_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_settings_aria_label = /** @type {((inputs?: Style_Guide_Manager_Settings_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Settings_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Parametres du guide de style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen für den Styleguide")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni della guida di stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки руководства по стилю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de la guía de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("样式指南设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイドの設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल गाइड सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações do guia de estilo")
	return /** @type {LocalizedString} */ ("Style guide settings")
});